<template>
  <div>
    <BCard>
  <b-row class="justify-content-start">
    <!-- Dropdown Selection -->
    <b-col cols="12" md="4" class="my-1">
      <v-select v-model="selectedItem" :options="selectOptions"></v-select>
    </b-col>

    <!-- Duration Picker -->
    <b-col cols="12" md="3" class="d-flex align-items-center my-1">
      <span class="mr-1"><strong>Duration:</strong></span>
      <Flatpickr
        id="duration-picker"
        v-model="selectedDuration"
        :config="flatpickrConfig"
        class="form-control w-100"
      ></Flatpickr>
    </b-col>

    <!-- Buttons -->
    <b-col cols="12" md="5" class="d-flex justify-content-center justify-content-md-end flex-wrap my-1">
      <b-button
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        variant="primary"
        class="btn-icon mx-1"
        @click="search"
        v-b-tooltip.hover="'Search'"
        size="sm"
      >
        <feather-icon icon="SearchIcon" />
      </b-button>
      <b-button
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        variant="danger"
        class="btn-icon mx-1"
        v-b-tooltip.hover="'Refresh'"
        size="sm"
      >
        <feather-icon icon="RefreshCwIcon" />
      </b-button>
      <b-button
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        variant="success"
        class="btn-icon mx-1"
        @click="exportAsPDF"
        v-b-tooltip.hover="'Export as PDF'"
        size="sm"
      >
        <feather-icon icon="DownloadIcon" />
      </b-button>
    </b-col>
  </b-row>
</BCard>

    <BCard class="table-card">
      <b-table
        hover
        :items="tableData"
        :fields="fields"
        :tbody-tr-class="tbodyTrClass"
      ></b-table>
    </BCard>
  </div>
</template>

<script>
import {
  BButton,
  BTable,
  BRow,
  BCol,
  BCard,
  BCardBody,
  BFormGroup,
  VBTooltip,
} from "bootstrap-vue";
import jsPDF from "jspdf";
import "jspdf-autotable";
import Flatpickr from "vue-flatpickr-component";
import vSelect from "vue-select";

export default {
  components: {
    BButton,
    BTable,
    BRow,
    BCol,
    BCard,
    BCardBody,
    Flatpickr,
    BFormGroup,
    vSelect,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      trialBalance: [
        { account: "Accounts Receivable", debit: 1000, credit: 0 },
        { account: "Accounts Payable", debit: 0, credit: 500 },
        { account: "Expense", debit: 2000, credit: 0 },
      ],
      fields: ["account", "debit", "credit"],
      selectedDuration: null,
      flatpickrConfig: {
        mode: "range",
        // Add any additional Flatpickr configurations as needed
      },
      selectedItem: { value: "current_year", label: "This Financial Year" },

      selectOptions: [
        { value: "current_year", label: "This Financial Year" },
        { value: "last_year", label: "Last Financial Year" },
        { value: "current_month", label: "This Month" },
        { value: "custom", label: "Custom" },
      ],
    };
  },
  computed: {
    tableData() {
      const totalDebit = this.getTotalDebit();
      const totalCredit = this.getTotalCredit();

      const tableDataWithTotal = [
        ...this.trialBalance,
        { account: "Total (MUR)", debit: totalDebit, credit: totalCredit },
      ];

      return tableDataWithTotal;
    },
  },
  methods: {
    exportAsPDF() {
      const doc = new jsPDF();
      doc.text("Trial Balance", 10, 10);
      doc.autoTable({
        head: [["Account", "Debit", "Credit"]],
        body: this.tableData.map(({ account, debit, credit }) => [
          account,
          debit,
          credit,
        ]),
        startY: 20,
      });
      doc.save("trial_balance.pdf");
    },
    getTotalDebit() {
      return this.trialBalance.reduce((total, { debit }) => total + debit, 0);
    },
    getTotalCredit() {
      return this.trialBalance.reduce((total, { credit }) => total + credit, 0);
    },
    tbodyTrClass(item, rowIndex) {
      if (item.account === "Total (MUR)") {
        return "total-row font-weight-bolder bg-secondary bg-darken-5";
      }
      return "";
    },
  },
};
</script>

<style>
.table-card .card-body {
  padding: 0;
}
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
